import React, { useState, useEffect } from "react";

export default function OwnNumber() {
  const [user, setUser] = useState();
  const BaseUserList = [
    {
      name: "gadar",
      count: 1,
      Desc: "lorem is one of the dummy text",
      create_time: "2022-08-08 12",
      Updated_time: "2022-08-08 12",
    },
    {
      name: "thakur",
      count: 1,
      Desc: "lorem is one of the dummy text",
      create_time: "2023-08-08 12",
      Updated_time: "2022-02-08 12",
    },
    {
      name: "dhami",
      count: 1,
      Desc: "lorem is one of the dummy text",
      create_time: "2022-08-08 12",
      Updated_time: "2022-08-08 12",
    },
    {
      name: "sardar",
      count: 1,
      Desc: "lorem is one of the dummy text",
      create_time: "2022-08-08 12",
      Updated_time: "2022-08-08 12",
    },
    {
      name: "official",
      count: 1,
      Desc: "lorem is one of the dummy text",
      create_time: "2022-08-08 12",
      Updated_time: "2022-08-08 12",
    },
  ];

  // useEffect(() => {
  //   console.log("useEffect", BaseUserList);
  //   fetch("https://jsonplaceholder.typicode.com/users")
  //     .then((response) => response.json())
  //     .then((json) => setUser(json));
  // }, []);
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div className="container-fluid">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
                <div className="card mb-3 mt-4">
                  <div className="card-header p-3 pt-2">
                    <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                      <i className="material-icons opacity-10">person</i>
                    </div>
                    <div className="card-body">
                      <form role="form" className="text-start mt-5">
                        <div className="card shadow-none border mb-5 bg_blue card_1">
                          <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                            Target Base
                          </span>
                          <div className="card-body text-lg-start text-center">
                            <div className="row">
                              <div className="col-md-3">
                                <div className="form-check  form-check_1">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="customRadio1"
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="customRadio1"
                                  >
                                    Own Numbers
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check form-check_1">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="customRadio1"
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="customRadio1"
                                  >
                                    Targeted Numbers
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-check  form-check_1">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id="customRadio1"
                                  />
                                  <label
                                    className="custom-control-label"
                                    for="customRadio1"
                                  >
                                    All Robi Numbers
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-body country_table">
                          <table
                            id="example"
                            className="table table-striped table-bordered table-sm"
                            // style="width:100%"
                          >
                            <thead>
                              <tr>
                                <th className="text-center p-0 width_1">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value=""
                                      id="fcustomCheck1"
                                    />
                                  </div>
                                </th>
                                <th className="text-center width_2">Name</th>
                                <th className="text-center">Number Count</th>
                                <th className="text-center">Description</th>
                                <th className="text-center">Create Time</th>
                                <th className="text-center">Update Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {BaseUserList.map((users) => {
                                return (
                                  <>
                                    <tr>
                                      <td className="text-center">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value=""
                                            id="fcustomCheck1"
                                          />
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        <div className="text-center">
                                          <div className="d-inline-block">
                                            <div className="d-flex align-items-center">
                                              <span className="d-block">
                                                <i className="material-icons opacity-10 size d-block">
                                                  info
                                                </i>
                                              </span>
                                              <span className="d-block ms-3">
                                                <i className="material-icons opacity-10 size d-block">
                                                  person
                                                </i>
                                              </span>
                                              <span className="d-block me-auto">
                                                {users.name}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        {users.count}
                                      </td>
                                      <td className="text-center">
                                        {users.Desc}
                                      </td>
                                      <td className="text-center">
                                        <div className="dropdown">
                                          <button
                                            className="btn color_1 dropdown-toggle"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                            <i className="material-icons opacity-10 size">
                                              person
                                            </i>
                                          </button>
                                          <ul
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton1"
                                          >
                                            <li>
                                              <a
                                                className="dropdown-item"
                                                href="#"
                                              >
                                                Action
                                              </a>
                                            </li>
                                            <li>
                                              <a
                                                className="dropdown-item"
                                                href="#"
                                              >
                                                Another action
                                              </a>
                                            </li>
                                            <li>
                                              <a
                                                className="dropdown-item"
                                                href="#"
                                              >
                                                Something else here
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        {" "}
                                        {users.Updated_time}
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
